import { useParams } from "react-router-dom";
import { useContent } from "@/context/ContentContext";

export default function Policies() {
  const { slug } = useParams();
  const p = useContent().policies[slug] || { title: "Not found", body: "" };
  return (
    <div className="max-w-3xl mx-auto px-6 lg:px-8 py-16">
      <h1 className="font-serif text-5xl font-bold" data-testid="policy-title">{p.title}</h1>
      <div className="prose mt-8 text-charcoal/80 leading-relaxed space-y-4" data-testid="policy-body">
        {(p.body || "").split(/\n\s*\n/).map((para, i) => <p key={i}>{para}</p>)}
      </div>
    </div>
  );
}
